'use strict';

var processInclude = require('base/util');
const { selectDefaultAttribute } = require('./product/detail');
const stickyComponent = document.querySelector('.stick');
const scrollTo = document.querySelector('.scrollable');


let current;

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/events'));

    registerQuantityListeners();
    registerCarouselListeners();
    registerShareModalListeners();
    registerAccordionListeners();
    smoothScroll();
});

function registerQuantityListeners() {
    var plus = $(".productDetailPage__quantity__increase");
    var minus = $(".productDetailPage__quantity__reduce");
    var quantity = $('#quantity-select-val');

    plus.click(function () {
        quantity.val(Number(quantity.val()) + Number(quantity.attr('step')));
    });

    minus.click(function () {
        if (Number(quantity.val()) > Number(quantity.attr('min'))) {
            quantity.val(Number(quantity.val()) - Number(quantity.attr('step')));
        }
    });
}

function registerCarouselListeners() {
    var imageCarousel = $("div[id^=pdpCarousel-]");

    var watchCarouselZoom = function () {
        $("#pdpCarouselZoom, .carousel-item").click(function () {
            imageCarousel.addClass("zoom");
        });
    }

    var watchCloseCarousel = function () {
        $("#pdpCarouselClose, .zoom-background").click(function () {
            imageCarousel.removeClass("zoom");
        });
    }

    $('body').on('product:afterAttributeSelect', function () {
        watchCarouselZoom();
        watchCloseCarousel();
    });

    watchCarouselZoom();
    watchCloseCarousel();
}

function registerShareModalListeners() {
    var shareModal = $("div[id^=shareModal]");

    var watchCloseShare = function (shareModal) {
        $("#shareClose").click(function () {
            shareModal.removeClass("share");
        })

        var copyTextButton = document.getElementById("shareLink");

        $("#shareLink").click(function () {
            navigator.clipboard.writeText(copyTextButton.value);

            alert("Copied to clipboard");
        })
    }

    $("#shareButton").click(function () {
        shareModal.addClass("share");
    });

    $('body').on('product:afterAttributeSelect', function () {
        watchCloseShare(shareModal);
    });

    watchCloseShare(shareModal);
}


//The smoothscroll and sticky functions support a sticky element on scroll.
// Use the 'stick' class on the element that you want to be sticky, and the scrollable class on the outerdiv of the element.
// See eucharist_us > productDetails.isml for an example. -EB 6/2024

function smoothScroll() {
    if (scrollTo && stickyComponent) {
        current = window.scrollY;
        sticky();
        window.requestAnimationFrame(smoothScroll);
    }
}


function sticky() {
    let outerDivHeight = scrollTo.getBoundingClientRect().height;
    let picHeight = stickyComponent.getBoundingClientRect().height;

    if (current < picHeight / 4) {
        stickyComponent.style.transform = 'translate3d(0, 0, 0)';
    }
    if (current >= picHeight / 4 && current <= (outerDivHeight - (picHeight * (3 / 4)))) {
        stickyComponent.style.transform = 'translate3d(0, ' + (current - picHeight / 4) + 'px, 0)';
    }

    if (current > (outerDivHeight - (picHeight * (3 / 4)))) {
        stickyComponent.style.transform = 'translate3d(0, ' + (outerDivHeight - picHeight) + 'px, 0)';
    }
}

function registerAccordionListeners() {
    var ship = $('.shipping-accordion');
    var returns = $('.returns-accordion');
    var questions = $('.questions-accordion');

    ship.expanded = false;
    returns.expanded = false;
    questions.expanded = false;


    ship.click(function () {
        toggleAccordion('.shipping-accordion', ship.expanded);
        ship.expanded = ship.expanded ? false : true;
    });

    returns.click(function () {
        toggleAccordion('.returns-accordion', returns.expanded);
        returns.expanded = returns.expanded ? false : true;

    });

    questions.click(function () {
        toggleAccordion('.questions-accordion', questions.expanded);
        questions.expanded = questions.expanded ? false : true;

    });

}

function toggleAccordion(name, expanded) {
    var accContent = $(name + ' .accordion-content');
    var accChevron = $(name + ' .icon-chevron-up');

    if (expanded) {
        accContent.removeClass('show');
        accChevron.addClass('icon-chevron-down');

    } else {
        accContent.addClass('show');
        accChevron.removeClass('icon-chevron-down');
    }
}